<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" title="微信公众号支付设置" width="800px" :loading="loading" @close="$emit('update:toSet',dialogVisible)">
      <el-table :data="merchantList" border style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          label="微信商户全称"
          prop="fReportMerchantName"
          align="center">
        </el-table-column>
        <el-table-column
          label="微信商户号"
          prop="fWxSubMchId"
          align="center">
        </el-table-column>
        <el-table-column
          label="微信渠道号"
          prop="fChannelId"
          align="center">
        </el-table-column>
        <el-table-column
          label="通道类型"
          prop="fPayType"
          align="center">
        </el-table-column>
        <el-table-column
          label="支付权限"
          prop="fCanTrade"
          align="center">
          <template slot-scope="scope">
            <span>{{ parseInt(scope.row.fCanTrade) === 1 ? '有': '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          :context="_self">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="setWechat(scope.row)">设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :visible="setDialogVisible" title="微信公众号支付设置" width="800px" @close="setDialogVisible = false">
      <div>
        <div class="wx-set-title-view">
          <h4>支付APPID</h4>
          <el-button type="success" size="mini" :disabled="readOnly" v-if="wxCongigInfo.appidConfigList.length < 5" @click="wxSetAddPayappIdDialogVisible = true">添加</el-button>
        </div>
        <el-table
          :data="wxCongigInfo.appidConfigList"
          stripe
          border
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            align="center"
            width="50">
          </el-table-column>
          <el-table-column
            prop="sub_appid"
            label="支付APPID"
            align="center"
            min-width="180">
          </el-table-column>
          <el-table-column
            prop="stateStr"
            label="状态"
            align="center"
            min-width="180">
          </el-table-column>
          <el-table-column
            label="操作"
            align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.stateStr === '未使用'"
                @click="handleWxPayAppidUseClick(scope.$index, scope.row)">启用</el-button>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table>
        <div>备注：最多添加5组，交易接口不上送时，默认上送状态为使用中的参数。</div>
        <!-- 支付APPID添加dialog -->
        <el-dialog
          title="支付APPID添加"
          append-to-body
          :visible.sync="wxSetAddPayappIdDialogVisible"
          width="500px"
          top="20vh"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          @close="$refs['wxSetAddPayappIdForm'].resetFields()">
          <div>
            <el-form
              ref="wxSetAddPayappIdForm"
              label-width="100px"
              label-position="left"
              :model="wxConfigInputInfo"
              :rules="{
                sub_appid: [
                  { required: true, message: '请输入支付APPID', trigger: 'blur' },
                  { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }
                ]}">
              <el-form-item label="支付APPID" prop="sub_appid">
                <el-input class="form-input" v-model="wxConfigInputInfo.sub_appid"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer">
            <el-button @click="wxSetAddPayappIdDialogCancelClick">取消</el-button>
            <el-button type="primary" :loading="buttonLoading" @click="wxSetAddPayappIdDialogConfirmClick">添加</el-button>
          </span>
        </el-dialog>
      </div>
      <div>
        <div class="wx-set-title-view">
          <h4>授权目录</h4>
          <el-button type="success" size="mini" :disabled="readOnly" v-if="wxCongigInfo.jsapiPathList.length < 5" @click="wxSetAddJsapiPathDialogVisible = true">添加</el-button>
        </div>
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="`支付授权目录${index + 1}`" v-for="(jsapiPath, index) in wxCongigInfo.jsapiPathList" :key="index">
            <el-input class="form-input" disabled :value="jsapiPath"></el-input>
          </el-form-item>
          <div v-if="wxCongigInfo.jsapiPathList.length <= 0">暂无授权目录信息</div>
        </el-form>
        <div>备注：最多5组</div>
        <!-- 授权目录添加dialog -->
        <el-dialog
          title="授权目录添加"
          append-to-body
          :visible.sync="wxSetAddJsapiPathDialogVisible"
          width="500px"
          top="20vh"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          @close="$refs['wxSetAddJsapiPathForm'].resetFields()">
          <div>
            <el-form
              ref="wxSetAddJsapiPathForm"
              label-width="100px"
              label-position="left"
              :model="wxConfigInputInfo"
              :rules="{
                jsapi_path: [
                  { required: true, message: '请输入授权目录', trigger: 'blur' },
                  { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' },
                  { pattern: /^(http|https):\/\/\S+\/$/, message: '授权目录必须以http或https开头，以/结尾', trigger: 'blur' }
                ]}">
              <el-form-item label="授权目录" prop="jsapi_path">
                <el-input class="form-input" v-model="wxConfigInputInfo.jsapi_path"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer">
            <el-button @click="wxSetAddJsapiPathDialogCancelClick">取消</el-button>
            <el-button type="primary" :loading="buttonLoading" @click="wxSetAddJsapiPathDialogConfirmClick">添加</el-button>
          </span>
        </el-dialog>
      </div>
      <div>
        <div class="wx-set-title-view">
          <h4>公众号关注</h4>
          <el-button type="success" :disabled="readOnly" size="mini" v-if="!wxCongigInfo.isAllHasSubscribeAppid" @click="wxSetAddSubscribeAppidDialogVisible = true">绑定</el-button>
        </div>
        <el-table
          :data="wxCongigInfo.appidConfigList"
          stripe
          border
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            align="center"
            width="50">
          </el-table-column>
          <el-table-column
            prop="sub_appid"
            label="支付APPID"
            align="center"
            min-width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.sub_appid || '无' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="subscribe_appid"
            label="关注APPID"
            align="center"
            min-width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.subscribe_appid || '无' }}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 公众号关注绑定dialog -->
        <el-dialog
          title="公众号关注绑定"
          append-to-body
          :visible.sync="wxSetAddSubscribeAppidDialogVisible"
          width="600px"
          top="20vh"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false">
          <div>
            <el-table
              :data="wxCongigInfo.appidConfigList"
              stripe
              border
              style="width: 100%">
              <el-table-column
                label="序号"
                type="index"
                align="center"
                width="50">
              </el-table-column>
              <el-table-column
                prop="sub_appid"
                label="支付APPID"
                align="center"
                min-width="180">
              </el-table-column>
              <el-table-column
                prop="subscribe_appid"
                label="关注APPID"
                align="center"
                min-width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.subscribe_appid">{{ scope.row.subscribe_appid }}</div>
                  <input placeholder="在此输入关注APPID" v-else v-model="wxConfigInputInfo.subscribeAddList[scope.$index].subscribe_appid">
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer">
            <el-button @click="wxSetAddSubscribeAppidDialogCancelClick">取消</el-button>
            <el-button type="primary" :loading="buttonLoading" @click="wxSetAddSubscribeAppidDialogConfirmClick">添加</el-button>
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { reportWechatMerchantList, getWxConfigInfo, setWxConfigInfo } from '@/api/merchant'
export default {
  name: 'WechatForm',
  props: {
    merchantId: {
      type: String,
      default: ''
    },
    // 商户业务类型，1线上，2线下
    payType: {
      type: Number,
      default: 1
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    toSet: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      wxCongigInfo: {
        appidConfigList: [],
        jsapiPathList: []
      },
      wxConfigInputInfo: {
        sub_appid: '',
        subscribe_appid: '',
        jsapi_path: '',
        subscribeAddList: []
      },
      wxSetAddPayappIdDialogVisible: false,
      wxSetAddJsapiPathDialogVisible: false,
      wxSetAddSubscribeAppidDialogVisible: false,
      buttonLoading: false,
      dialogVisible: false, // 是否显示弹窗
      selecetId: '', // 选中的商户id
      selectedPayTypeCode: '', // 选中商户的通道类型id
      setDialogVisible: false, // 设置微信
      merchantList: []// 商户列表
    }
  },
  watch: {
    toSet (val, oldVal) {
      if (val) {
        this.getMerchantList()
      }
    }
  },
  mounted () {
    if (this.merchantId) {
      this.getMerchantList()
    }
  },
  methods: {
    /**
             * @description 查询商户微信公众号信息
             */
    getMerchantList () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const params = qs.stringify({
          merchantId: this.merchantId
        })
        reportWechatMerchantList(params).then(response => {
          this.loading = false
          if (parseInt(response.result_cde) === 0) {
            if (response.data.length === 0) {
              this.$message({
                message: '该商户没有可设置微信公众号信息的子商户',
                type: 'warning'
              })
              this.$emit('update:toSet', false)
            } else {
              this.merchantList = response.data
              this.dialogVisible = true
            }
            resolve()
          } else {
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch(e => {
          reject(e)
        })
      }).catch(function () {

      })
    },
    /**
             * @description 查询商户微信公众号信息
             */
    getWxConfigInfo () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const params = qs.stringify({
          fMerchantId: this.merchantId,
          subMchId: this.selecetId,
          fPayType: this.selectedPayTypeCode
        })
        getWxConfigInfo(params).then(response => {
          this.loading = false
          if (response.error_code === '0') {
            const responseData = response.data
            const usedSubAppidList = (responseData.used_sub_appid && responseData.used_sub_appid.split(',')) || []
            const usedSubAppid = usedSubAppidList[usedSubAppidList.length - 1]
            const jsapiPathList = responseData.jsapi_path_list.jsapi_path_list || []
            let appidConfigList = responseData.appid_config_list.appid_config_list || []
            appidConfigList = appidConfigList.filter(element => {
              return (element.sub_appid && element.sub_appid !== 'null') || (element.subscribe_appid && element.subscribe_appid !== 'null')
            })
            appidConfigList.forEach(element => {
              element.stateStr = appidConfigList.length === 1 ? '使用中' : '未使用'
              if (element.sub_appid === usedSubAppid) {
                element.stateStr = '使用中'
              }
              if (element.subscribe_appid) {
                element.hasSubscribeAppid = true
              }
            })
            this.wxCongigInfo = {
              appidConfigList: appidConfigList,
              jsapiPathList: jsapiPathList,
              isAllHasSubscribeAppid: appidConfigList.every(element => {
                return element.hasSubscribeAppid === true
              })
            }
            this.wxConfigInputInfo.subscribeAddList = JSON.parse(JSON.stringify(appidConfigList))
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          reject(e)
        })
      })
    },
    /**
             * @description 微信公众号设置支付APPID启用点击
             */
    handleWxPayAppidUseClick (index, row) {
      console.log(index, row)
      this.$confirm('公众号支付时，是否使用该参数？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setWxConfigInfo(1, {
          sub_appid: row.sub_appid
        }).then(() => {
          this.$message({
            message: '启用成功',
            type: 'success'
          })
          this.wxSetAddPayappIdDialogVisible = false
          this.getWxConfigInfo()
        })
      }).catch(() => {
        console.log('取消')
      })
    },
    /**
             * @description 微信公众号设置授权目录添加Dialog取消点击
             */
    wxSetAddJsapiPathDialogCancelClick () {
      this.$confirm('是否确认放弃添加?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.wxSetAddJsapiPathDialogVisible = false
      }).catch(() => {
        console.log('取消')
      })
    },
    /**
             * @description 微信公众号设置授权目录添加Dialog确定点击
             */
    wxSetAddJsapiPathDialogConfirmClick () {
      this.$refs.wxSetAddJsapiPathForm.validate((valid) => {
        if (valid) {
          this.$confirm('提交后不可修改，请确认是否提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.setWxConfigInfo(3, {
              jsapi_path: this.wxConfigInputInfo.jsapi_path
            }).then(() => {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.wxSetAddJsapiPathDialogVisible = false
              this.getWxConfigInfo()
            })
          }).catch(() => {
            console.log('取消')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
             * @description 微信公众号设置推荐关注APPID添加Dialog取消点击
             */
    wxSetAddSubscribeAppidDialogCancelClick () {
      this.$confirm('是否确认放弃绑定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.wxSetAddSubscribeAppidDialogVisible = false
      }).catch(() => {
        console.log('取消')
      })
    },
    /**
             * @description 微信公众号设置推荐关注APPID添加Dialog确定点击
             */
    wxSetAddSubscribeAppidDialogConfirmClick () {
      const paramsList = []
      this.wxConfigInputInfo.subscribeAddList.forEach(element => {
        const subscribeAppid = element.subscribe_appid.replace(/ /g, '')
        if (subscribeAppid && !element.hasSubscribeAppid) {
          paramsList.push({
            sub_appid: element.sub_appid,
            subscribe_appid: subscribeAppid
          })
        }
      })
      if (paramsList.length > 0) {
        this.$confirm('提交后不可修改，请确认是否提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const ajaxList = paramsList.map(element => {
            return this.setWxConfigInfo(2, element)
          })
          await Promise.all(ajaxList)
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.wxSetAddSubscribeAppidDialogVisible = false
          this.getWxConfigInfo()
        }).catch(() => {
          console.log('取消')
        })
      } else {
        this.$message({
          message: '至少填写一个关注APPID',
          type: 'warning'
        })
      }
    },
    /**
             * @description 配置商户微信公众号参数
             */
    setWxConfigInfo (configType, wxConfigInfo) {
      console.log(this.merchantId)
      return new Promise((resolve, reject) => {
        this.buttonLoading = true
        const params = qs.stringify({
          merchantId: this.merchantId,
          fPayType: this.selectedPayTypeCode,
          configType: configType,
          sub_appid: wxConfigInfo.sub_appid || '',
          subscribe_appid: wxConfigInfo.subscribe_appid || '',
          jsapi_path: wxConfigInfo.jsapi_path || '',
          subMchId: this.selecetId
        })
        setWxConfigInfo(params).then(response => {
          this.buttonLoading = false
          if (response.error_code === '0') {
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            // resolve(false)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    /**
             * 微信公众号设置支付APPID添加Dialog取消点击
             */
    wxSetAddPayappIdDialogCancelClick () {
      this.$confirm('是否确认放弃添加?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.wxSetAddPayappIdDialogVisible = false
      }).catch(() => {
        console.log('取消')
      })
    },
    /**
             * 微信公众号设置支付APPID添加Dialog确定点击
             */
    wxSetAddPayappIdDialogConfirmClick () {
      this.$refs.wxSetAddPayappIdForm.validate((valid) => {
        if (valid) {
          this.$confirm('提交后不可修改，请确认是否提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.setWxConfigInfo(1, {
              sub_appid: this.wxConfigInputInfo.sub_appid
            }).then(() => {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.wxSetAddPayappIdDialogVisible = false
              this.getWxConfigInfo()
            })
          }).catch(() => {
            console.log('取消')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    setWechat (row) {
      this.selecetId = row.fWxSubMchId
      this.selectedPayTypeCode = row.fPayTypeCode
      this.setDialogVisible = true
      this.getWxConfigInfo()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @mixin flex-horizontal {
        display: -webkit-box;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .wx-set-title-view {
        @include flex-horizontal;
        justify-content: space-between;
    }
    .form-input {
      width: 360px;
    }
</style>
